import Link from 'found/Link';
import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';

import BadgeActive from 'src/components/Badge/BadgeActive';
import BadgeTradePointType from 'src/components/Badge/BadgeTradePointType';
import Loading from 'src/components/Loading';
import UUID from 'src/components/UUID';
import displayUserName from 'src/util/i18n/decorators/displayUserName';

/**
 * Description
 * @param {object} props
 * @param {object} props.trader
 * @returns {React.ReactElement} - AdminTradeRuleListTrader component
 */
function AdminTradeRuleListTrader({ trader = null }) {
  const intl = useIntl();

  if (!trader) {
    return <Loading />;
  }

  const {
    tradePoint, community, user, userId,
  } = trader;
  const { uuid: tradePointId } = tradePoint;

  const tradePointBadge = <BadgeTradePointType type={tradePoint.type} />;
  const userName = displayUserName(intl, user, userId);

  if (user || userName) {
    // Without a resolved user (e.g. System) there is no profile, email or activity to show.
    return (
      <>
        <UUID uuid={tradePointId} />
        <br />
        {tradePointBadge}
        <br />
        {user ? (
          <>
            <Link to={`/admin/users/${user.uuid}`}>{userName}</Link>
            <br />
            {user.email}
            <br />
            <BadgeActive start={user.active.start} finish={user.active.finish} />
          </>
        ) : (
          <>
            {userName}
            <br />
            <UUID uuid={userId} />
          </>
        )}
      </>
    );
  }

  if (community) {
    const { uuid, title, active } = community;

    return (
      <>
        <UUID uuid={tradePointId} />
        <br />
        {tradePointBadge}
        <br />
        <Link to={`/admin/communities/${uuid}`}>
          {title}
        </Link>
        <br />
        <BadgeActive start={active.start} finish={active.finish} />
      </>
    );
  }

  return (
    <>
      <UUID uuid={tradePointId} />
      <br />
      {tradePointBadge}
    </>
  );
}

AdminTradeRuleListTrader.propTypes = {
  trader: PropTypes.shape({
    tradePoint: PropTypes.shape({
      uuid: PropTypes.string,
      type: PropTypes.string,
    }),
    community: PropTypes.shape({
      uuid: PropTypes.string,
      title: PropTypes.string,
      active: PropTypes.shape({
        start: PropTypes.number,
        finish: PropTypes.number,
      }),
    }),
    userId: PropTypes.string,
    user: PropTypes.shape({
      uuid: PropTypes.string,
      email: PropTypes.string,
      givenName: PropTypes.string,
      familyName: PropTypes.string,
      active: PropTypes.shape({
        start: PropTypes.number,
        finish: PropTypes.number,
      }),
    }),
  }),
};

export default AdminTradeRuleListTrader;
